import dispatcher from '../dispatcher/dispatcher'

export function fetchEmployees(customer){
    dispatcher.dispatch(
        {
            type : "FETCH_EMPLOYEES"       
        }
    )
}


export function updateCustomers(){
    dispatcher.dispatch(
        {
            type : "UPDATE_CUSTOMERS",
        }
    )
}